var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJourniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 98,
    viewBox: "0 0 198 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_60_31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188 63.115V31.115H183V63.115H188ZM126.116 40.4669C125.458 41.5333 125.129 42.751 125.129 44.1201V63.3138H120.469V32.9829H124.971V37.5642H125.287C125.84 36.0634 126.84 34.8457 128.288 33.911C129.737 32.9764 131.369 32.509 133.186 32.509C133.528 32.509 133.956 32.5156 134.469 32.5288C134.983 32.5419 135.371 32.5617 135.634 32.588V37.3272C135.476 37.2877 135.114 37.2285 134.548 37.1495C133.995 37.0573 133.409 37.0113 132.791 37.0113C131.316 37.0113 130 37.3206 128.841 37.9394C127.696 38.5449 126.788 39.3875 126.116 40.4669ZM56.1795 63.9457C53.4413 63.9457 51.0387 63.294 48.9719 61.9907C46.9183 60.6875 45.3122 58.8642 44.1537 56.5209C43.0084 54.1777 42.4357 51.4395 42.4357 48.3063C42.4357 45.1469 43.0084 42.3889 44.1537 40.0325C45.3122 37.6761 46.9183 35.8462 48.9719 34.5429C51.0387 33.2397 53.4413 32.588 56.1795 32.588C58.9177 32.588 61.3137 33.2397 63.3674 34.5429C65.4342 35.8462 67.0403 37.6761 68.1856 40.0325C69.3441 42.3889 69.9233 45.1469 69.9233 48.3063C69.9233 51.4395 69.3441 54.1777 68.1856 56.5209C67.0403 58.8642 65.4342 60.6875 63.3674 61.9907C61.3137 63.294 58.9177 63.9457 56.1795 63.9457ZM56.1795 59.7594C58.2594 59.7594 59.971 59.2262 61.3137 58.1599C62.6565 57.0936 63.6504 55.6916 64.2955 53.9539C64.9405 52.2162 65.2631 50.3337 65.2631 48.3063C65.2631 46.279 64.9405 44.3899 64.2955 42.6391C63.6504 40.8882 62.6565 39.473 61.3137 38.3935C59.971 37.314 58.2594 36.7743 56.1795 36.7743C54.0995 36.7743 52.3881 37.314 51.0453 38.3935C49.7025 39.473 48.7086 40.8882 48.0635 42.6391C47.4185 44.3899 47.096 46.279 47.096 48.3063C47.096 50.3337 47.4185 52.2162 48.0635 53.9539C48.7086 55.6916 49.7025 57.0936 51.0453 58.1599C52.3881 59.2262 54.0995 59.7594 56.1795 59.7594ZM24.298 77.2753C24.8246 76.1169 25.0879 74.7017 25.0879 73.0298V32.5884H29.9851L29.8761 60.6289V75.0835C29.8761 77.2334 29.6227 77.6879 28.9899 78.823C28.8632 79.0502 28.7214 79.3047 28.5633 79.6054C27.6155 81.409 26.2793 82.7781 24.5548 83.7127C22.8302 84.6474 20.7963 85.1147 18.453 85.1147C16.2414 85.1147 14.2733 84.7132 12.5488 83.9102C10.8243 83.094 9.46833 81.9355 8.481 80.4348C7.49367 78.934 7 77.1503 7 75.0835H11.8182C11.8182 76.2288 12.1012 77.2293 12.6673 78.0849C13.2465 78.9275 14.0364 79.5857 15.0369 80.0596C16.0374 80.5335 17.1761 80.7705 18.453 80.7705C19.8616 80.7705 21.0596 80.4743 22.0469 79.8819C23.0343 79.2895 23.7846 78.4206 24.298 77.2753ZM98.0791 62.1092C99.5798 61.0297 100.686 59.7199 101.397 58.1796H101.712V63.3138H106.373V32.9829H101.712V50.9129C101.712 52.8086 101.298 54.3686 100.468 55.5928C99.6522 56.8171 98.6386 57.7255 97.4275 58.3179C96.2295 58.9103 95.0512 59.2065 93.8927 59.2065C91.9576 59.2065 90.3647 58.5483 89.1141 57.2318C87.8766 55.9154 87.2579 54.1513 87.2579 51.9397V32.9829H82.5977V52.2557C82.5977 54.8359 83.0189 56.9751 83.8615 58.6733C84.704 60.3584 85.8624 61.6222 87.3369 62.4647C88.8113 63.294 90.4963 63.7087 92.392 63.7087C94.6826 63.7087 96.5783 63.1755 98.0791 62.1092ZM154.855 34.0098C153.406 34.9444 152.327 36.1819 151.616 37.7221H151.221V32.9829H146.719V63.3138H151.379V45.0679C151.379 43.3039 151.715 41.8031 152.386 40.5657C153.058 39.3282 153.973 38.387 155.131 37.7419C156.303 37.0968 157.632 36.7743 159.12 36.7743C161.279 36.7743 162.977 37.4457 164.214 38.7885C165.452 40.1181 166.071 41.9743 166.071 44.357V63.3138H170.731V44.0411C170.731 41.4608 170.303 39.3282 169.447 37.6432C168.592 35.945 167.394 34.6812 165.853 33.8518C164.313 33.0093 162.516 32.588 160.463 32.588C158.172 32.588 156.303 33.0619 154.855 34.0098Z",
    fill: "#2F2F2F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_60_31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188 63.115V31.115H183V63.115H188ZM126.116 40.4669C125.458 41.5332 125.129 42.751 125.129 44.1201V63.3138H120.469V32.9829H124.971V37.5642H125.287C125.84 36.0634 126.84 34.8457 128.288 33.911C129.737 32.9764 131.369 32.509 133.186 32.509C133.528 32.509 133.956 32.5156 134.469 32.5288C134.983 32.5419 135.371 32.5617 135.634 32.588V37.3272C135.476 37.2877 135.114 37.2285 134.548 37.1495C133.995 37.0573 133.409 37.0113 132.791 37.0113C131.316 37.0113 130 37.3206 128.841 37.9394C127.696 38.5449 126.788 39.3874 126.116 40.4669ZM56.1795 63.9456C53.4413 63.9456 51.0387 63.294 48.9719 61.9907C46.9183 60.6875 45.3122 58.8642 44.1537 56.5209C43.0084 54.1777 42.4357 51.4395 42.4357 48.3063C42.4357 45.1469 43.0084 42.3889 44.1537 40.0325C45.3122 37.6761 46.9183 35.8462 48.9719 34.5429C51.0387 33.2396 53.4413 32.588 56.1795 32.588C58.9177 32.588 61.3137 33.2396 63.3674 34.5429C65.4342 35.8462 67.0403 37.6761 68.1856 40.0325C69.3441 42.3889 69.9233 45.1469 69.9233 48.3063C69.9233 51.4395 69.3441 54.1777 68.1856 56.5209C67.0403 58.8642 65.4342 60.6875 63.3674 61.9907C61.3137 63.294 58.9177 63.9456 56.1795 63.9456ZM56.1795 59.7594C58.2594 59.7594 59.971 59.2262 61.3137 58.1599C62.6565 57.0936 63.6504 55.6916 64.2955 53.9539C64.9405 52.2162 65.2631 50.3336 65.2631 48.3063C65.2631 46.279 64.9405 44.3899 64.2955 42.6391C63.6504 40.8882 62.6565 39.473 61.3137 38.3935C59.971 37.314 58.2594 36.7743 56.1795 36.7743C54.0995 36.7743 52.3881 37.314 51.0453 38.3935C49.7025 39.473 48.7086 40.8882 48.0635 42.6391C47.4185 44.3899 47.096 46.279 47.096 48.3063C47.096 50.3336 47.4185 52.2162 48.0635 53.9539C48.7086 55.6916 49.7025 57.0936 51.0453 58.1599C52.3881 59.2262 54.0995 59.7594 56.1795 59.7594ZM24.298 77.2753C24.8246 76.1169 25.0879 74.7017 25.0879 73.0298V32.5884H29.9851L29.8761 60.6289V75.0835C29.8761 77.2334 29.6227 77.6879 28.9899 78.823C28.8632 79.0502 28.7214 79.3047 28.5633 79.6054C27.6155 81.409 26.2793 82.7781 24.5548 83.7127C22.8302 84.6474 20.7963 85.1147 18.453 85.1147C16.2414 85.1147 14.2733 84.7132 12.5488 83.9102C10.8243 83.094 9.46833 81.9355 8.481 80.4348C7.49367 78.934 7 77.1503 7 75.0835H11.8182C11.8182 76.2288 12.1012 77.2292 12.6673 78.0849C13.2465 78.9275 14.0364 79.5857 15.0369 80.0596C16.0374 80.5335 17.1761 80.7705 18.453 80.7705C19.8616 80.7705 21.0596 80.4743 22.0469 79.8819C23.0343 79.2895 23.7846 78.4206 24.298 77.2753ZM98.0791 62.1092C99.5798 61.0297 100.686 59.7199 101.397 58.1796H101.712V63.3138H106.373V32.9829H101.712V50.9129C101.712 52.8086 101.298 54.3685 100.468 55.5928C99.6522 56.8171 98.6386 57.7255 97.4275 58.3179C96.2295 58.9103 95.0512 59.2065 93.8927 59.2065C91.9576 59.2065 90.3647 58.5482 89.1141 57.2318C87.8766 55.9154 87.2579 54.1513 87.2579 51.9397V32.9829H82.5977V52.2556C82.5977 54.8359 83.0189 56.9751 83.8615 58.6733C84.704 60.3584 85.8624 61.6221 87.3369 62.4647C88.8113 63.294 90.4963 63.7087 92.392 63.7087C94.6826 63.7087 96.5783 63.1755 98.0791 62.1092ZM154.855 34.0098C153.406 34.9444 152.327 36.1819 151.616 37.7221H151.221V32.9829H146.719V63.3138H151.379V45.0679C151.379 43.3039 151.715 41.8031 152.386 40.5657C153.058 39.3282 153.973 38.3869 155.131 37.7419C156.303 37.0968 157.632 36.7743 159.12 36.7743C161.279 36.7743 162.977 37.4457 164.214 38.7885C165.452 40.1181 166.071 41.9743 166.071 44.357V63.3138H170.731V44.0411C170.731 41.4608 170.303 39.3282 169.447 37.6432C168.592 35.9449 167.394 34.6812 165.853 33.8518C164.313 33.0093 162.516 32.588 160.463 32.588C158.172 32.588 156.303 33.0619 154.855 34.0098Z",
    fill: "#2F2F2F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_60_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 8.33333C193 12.3834 189.642 27 185.5 27C181.358 27 178 12.3834 178 8.33333C178 4.28325 181.358 1 185.5 1C189.642 1 193 4.28325 193 8.33333Z",
    fill: "#2F2F2F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_60_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 8.5,
    r: 3.5,
    fill: "#FFCB74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_60_31",
    x: 0.821497,
    y: 0.976074,
    width: 193.357,
    height: 96.4957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08925
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_60_31",
    x: 0.821497,
    y: 0.976074,
    width: 193.357,
    height: 96.4957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08925
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_60_31",
    x: 173.077,
    y: 1,
    width: 24.8462,
    height: 35.8462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.92308
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.46154
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_60_31",
    x: 175.821,
    y: 5,
    width: 19.357,
    height: 19.357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.08925
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60_31",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourniLogo);
export default __webpack_public_path__ + "static/media/journi-logo.185c363cad5bb0650817826ebe85dd83.svg";
export { ForwardRef as ReactComponent };